document.addEventListener('DOMContentLoaded', function() {
    const contentElement = document.querySelector('.content');
    if (!contentElement) return;

    const sections = Array.from(document.querySelectorAll('.editor'));
    const navLinks = Array.from(document.querySelectorAll('.js-scroll-sidebar a'));
    const offset = 120;

    function updateActiveClass() {
        let currentActive = null;
        const scrollY = window.scrollY + offset;

        sections.forEach((section, index) => {
            const sectionTop = section.offsetTop;
            const sectionHeight = section.offsetHeight;

            if (scrollY >= sectionTop && scrollY < sectionTop + sectionHeight) {
                currentActive = index;
            }
        });

        navLinks.forEach((link, index) => {
            if (index === currentActive) {
                link.parentElement.classList.add('is-active');
            } else {
                link.parentElement.classList.remove('is-active');
            }
        });
    }

    window.addEventListener('scroll', updateActiveClass);
    updateActiveClass();
});
